/**
 * Created by Xuz on 2020/01/08.
 * xuz@live.cn
 */
let _targetNameI = 0
let _endNodeNameI = 0
let _transNameI = 0
let _linkNameI = 0

class WFHelper {
  /*
   * 获得事件的X,Y坐标
   */
  static getPos (event, CTM) {
    let pos = []

    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1

    // chrome和firefox下各不一样
    if (isFirefox) {
      pos.x = (event.clientX - CTM.e) / CTM.a
      pos.y = (event.clientY - CTM.f) / CTM.d
    } else {
      pos.x = event.offsetX
      pos.y = event.offsetY
    }

    return pos
  }

  static getRect (elSvg) {
    // return elSvg.bbox()
    let tmp = elSvg.bbox()
    let matrix = elSvg.matrix()
    let rect = []
    rect.x = tmp.x + matrix.e
    rect.y = tmp.y + matrix.f
    rect.width = tmp.width
    rect.height = tmp.height

    return rect
  }

  static getElementCenterPos (elSvg) {
    let tmp = elSvg.bbox()
    let matrix = elSvg.matrix()
    let pos = []
    pos.x = tmp.x + matrix.e + (tmp.w / 2)
    pos.y = tmp.y + matrix.f + (tmp.h / 2)
    return pos
  }

  /**
   * 获得一个SVG对象的四角坐标
   */
  static getBound (elSvg) {
    let tmp = elSvg.bbox()
    let matrix = elSvg.matrix()
    let bound = []
    bound.x1 = tmp.x + matrix.e
    bound.y1 = tmp.y + matrix.f
    bound.x2 = bound.x1 + tmp.width
    bound.y2 = bound.y1 + tmp.height

    return bound
  }

  /**
   * 检查一个点坐标是否在某个范围坐标之内
   */
  static isInBound (point, bound) {
    if (point.x > bound.x1 &&
      point.x < bound.x2 &&
      point.y < bound.y2 &&
      point.y > bound.y1) {
      return true
    }
    return false
  }

  static getReal (el, attr, value) {
    while (el != null) {
      if (el.attr(attr) === value) {
        return el
      }
      el = el.parent()
    }
    return null
  }

  /**
   * 修正坐标，在画线时，因每个对象外都有一个Container，并非获得此Container的中心
   * 而是使用两个中心的坐标来获得斜线与Container交接的坐标
   */
  static fixLinkPos (startPos, endPos, endRect, iFix) {
    this.extendRect(endRect, 8)
    iFix = iFix || 0
    let xL = Math.abs(endPos.x - startPos.x)
    let yL = Math.abs(endPos.y - startPos.y)
    let pos = []

    if (xL >= yL) {
      if (endPos.x > startPos.x) {
        if (endPos.y > startPos.y) {
          pos.x = endPos.x - endRect.width / 2 - iFix
          let fixY = yL / xL * endRect.width / 2
          pos.y = endPos.y - fixY
        } else {
          pos.x = endPos.x - endRect.width / 2 - iFix
          let fixY = yL / xL * endRect.width / 2
          pos.y = endPos.y + fixY
        }
      } else {
        if (endPos.y > startPos.y) {
          pos.x = endPos.x + endRect.width / 2 + iFix
          let fixY = yL / xL * endRect.width / 2
          pos.y = endPos.y - fixY
        } else {
          pos.x = endPos.x + endRect.width / 2 + iFix
          let fixY = yL / xL * endRect.width / 2
          pos.y = endPos.y + fixY
        }
      }
    } else {
      if (endPos.x > startPos.x) {
        if (endPos.y > startPos.y) {
          pos.y = endPos.y - endRect.height / 2 - iFix
          let fixX = xL / yL * endRect.height / 2
          pos.x = endPos.x - fixX
        } else {
          pos.y = endPos.y + endRect.height / 2 + iFix
          let fixX = xL / yL * endRect.height / 2
          pos.x = endPos.x - fixX
        }
      } else {
        if (endPos.y > startPos.y) {
          pos.y = endPos.y - endRect.height / 2 - iFix
          let fixX = xL / yL * endRect.height / 2
          pos.x = endPos.x + fixX
        } else {
          pos.y = endPos.y + endRect.height / 2 + iFix
          let fixX = xL / yL * endRect.height / 2
          pos.x = endPos.x + fixX
        }
      }
    }
    return pos
  }

  /**
   * 扩展一个范围
   */
  static extendRect (rect, iSize) {
    rect.x -= iSize
    rect.y -= iSize
    rect.width += iSize * 2
    rect.height += iSize * 2
  }

  static getSelectedElementId (event) {
    const currentSvgEl = event.currentTarget
    let uuid = currentSvgEl.getAttribute('uuid')

    if (uuid === '' || uuid == null) {
      uuid = this.getSvgAttributeBubbling(event.target, 'uuid', 'div')
    }

    if (uuid === '' || uuid === null) {
      return null
    } else {
      return uuid
    }
  }

  static getSvgAttributeBubbling (node, attrName, fenceName) {
    if (node == null || node.tagName === fenceName) {
      return null
    }

    let value = node.getAttribute(attrName)
    if (value === '' || value == null) {
      return this.getSvgAttributeBubbling(node.parentNode, attrName)
    } else {
      return value
    }
  }

  /**
   * 将指定form的元素转换成xml的描述节点集合
   */
  static createWFFormAttributesNode (formData, oXml) {
    let tmp = []
    for (let i in formData) {
      let val = formData[i] ? formData[i] : ''
      let node = oXml.createElement('form-attribute')
      node.setAttribute('name', i)
      let dataNode = oXml.createCDATASection(val)
      node.appendChild(dataNode)
      tmp.push(node)
    }

    return tmp
  }

  /**
   * 删除表单相关的数据
   */
  static removeWFFormAttributes (nodeXml) {
    let formAttributeNodes = nodeXml.getElementsByTagName('form-attribute')
    /*
     * The problem is that document.getElementsByTagName() returns a NodeList, not an Array.
     * The content, and therefore length, of a NodeList is updated when you remove an element from the DOM that's in the NodeList.
     * So when you remove the first element, the NodeList gets shorter and a new first element occupies index 0.
     * Updating index in the loop therefore makes you miss at least one element, possibly more depending on the length of the result.
     */
    while (formAttributeNodes[0]) {
      formAttributeNodes[0].parentNode.removeChild(formAttributeNodes[0])
    }
  }

  /**
   * 将指定node中的属性重新恢复至表单当中
   */
  static pushWFFormAttributes (formData, nodeXml) {
    let vals = []
    let attrNodes = nodeXml.getElementsByTagName('form-attribute')
    for (let i = 0; i < attrNodes.length; i++) {
      let node = attrNodes[i]
      vals[node.getAttribute('name')] = node.textContent
    }
    for (let i in formData) {
      let v = vals[i]
      if (!v) {
        v = ''
      }
      if (v !== '') {
        if (typeof formData[i] === 'number') {
          formData[i] = v * 1
        } else if (typeof formData[i] === 'object' && formData[i] instanceof Array) {
          formData[i] = v.split(',')
        } else {
          formData[i] = v
        }
      }
    }
  }

  /**
   * 获得流程的名字
   */
  static getWorkFlowName () {
    return '未命名流程'
  }

  /**
   * 获得起点的名称
   */
  static getStartNodeName () {
    return '本流程起点'
  }

  /**
   * 获得下一个对象的名字
   */
  static getNextTargetName () {
    return '节点' + (++_targetNameI)
  }

  /**
   * 获得下个结点的名字
   */
  static getNextEndNodeName () {
    return '流程结束' + (++_endNodeNameI)
  }

  /**
   * 获得下一个转换点的名字
   */
  static getNextTransName () {
    return '状态点' + (++_transNameI)
  }

  /**
   * 获得下一个条件的名字
   */
  static getNextLinkName () {
    return '条件' + (++_linkNameI)
  }

  static decrLinkName () {
    _linkNameI--
  }

  static resetNamesIndex () {
    _targetNameI = 0
    _endNodeNameI = 0
    _transNameI = 0
    _linkNameI = 0
  }
}

export default WFHelper
